export function buildWalletBeneficiary ({ id, email }) {
    return {
        email,
        id,
    }
}
